import { Bounce, ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';

// Unified function to show either Toast or Swal
export function showNotification(type, msg = '', autoClose = 2000) {
  // If type is toast-success, show a success toast notification
  if (type === 'toast-success') {
    toast(msg, {
      position: 'top-right',
      autoClose: autoClose,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: 'light',
      transition: Bounce,
    });
  }
  // If type is toast-error, show an error toast notification
  else if (type === 'toast-error') {
    toast.error(msg, {
      position: 'top-right',
      autoClose: autoClose,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: 'light',
      transition: Bounce,
    });
  } else if (type === 'toast-info') {
    toast.info(msg, {
      position: 'top-right',
      autoClose: autoClose,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: 'light',
      transition: Bounce,
    });
  }
  // If type is swal-success, show a success Swal notification
  else if (type === 'swal-success') {
    Swal.fire({
      text: msg,
      icon: 'success',
      allowOutsideClick: false,
      showConfirmButton: false,
      width: '25rem',
      timer: autoClose,
    });
  }
  // If type is swal-error, show an error Swal notification
  else if (type === 'swal-error') {
    Swal.fire({
      text: msg,
      icon: 'error',
      allowOutsideClick: false,
      showConfirmButton: false,
      width: '25rem',
      timer: autoClose,
    });
  } else if (type === 'swal-info') {
    Swal.fire({
      text: msg,
      icon: 'info',
      allowOutsideClick: false,
      showConfirmButton: false,
      width: '25rem',
      timer: autoClose,
    });
  }
}

export function MessagePopup(type, msg = '', autoClose = 2000) {
  // Toast notifications remain the same
  if (type === 'toast-success') {
    toast(msg, {
      position: 'top-right',
      autoClose: autoClose,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: 'light',
      transition: Bounce,
    });
  } else if (type === 'toast-error') {
    toast.error(msg, {
      position: 'top-right',
      autoClose: autoClose,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: 'light',
      transition: Bounce,
    });
  } else if (type === 'toast-info') {
    toast.info(msg, {
      position: 'top-right',
      autoClose: autoClose,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: 'light',
      transition: Bounce,
    });
  }

  // SweetAlert2 notifications with a close button (manual close)
  else if (type === 'swal-success') {
    Swal.fire({
      text: msg,
      icon: 'success',
      allowOutsideClick: false,
      showConfirmButton: true,   // show close button
      confirmButtonText: 'Close',
      width: '25rem',
      timer: undefined,          // remove auto-close
    });
  } else if (type === 'swal-error') {
    Swal.fire({
      text: msg,
      icon: 'error',
      allowOutsideClick: false,
      showConfirmButton: true,
      confirmButtonText: 'Close',
      width: '25rem',
      timer: undefined,
    });
  } else if (type === 'swal-info') {
    Swal.fire({
      text: msg,
      icon: 'info',
      allowOutsideClick: false,
      showConfirmButton: true,
      confirmButtonText: 'Close',
      width: '25rem',
      timer: undefined,
    });
  }
}

// Export NotificationContainer for global use (Toast)
export function NotificationContainer() {
  return <ToastContainer />;
}
